import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "../store";
import { baseUrl } from "config/config";
import { getApiCall, postApiCall } from "../../services/apiHelper";


export interface DebtData {
  lender ?: string | undefined;
  interestRate?: string | undefined;
  maturity?: string | undefined |null;
  outstandingBalance?: number | undefined | null;  
}

interface InitialState {
  data: DebtData;
  error: string;
  loading: boolean;
  cacheKey: string | undefined;
  isNoData: boolean;
  isDirty: boolean; // Track if form has unsaved changes
}

const initialState: InitialState = {
  data: {} as DebtData,
  error: '',
  loading: false,
  cacheKey: undefined,
  isNoData: false,
  isDirty: false,
};

const debtFormSlice = createSlice({
  name: "debtForm",
  initialState,
  reducers: { 
    resetState: (state) => {
      state.data = {} as DebtData;
      state.error = "";
      state.loading = false;
      state.cacheKey = undefined;
      state.isNoData = false;
    },

  },
  extraReducers: (builder) => {
    builder.addCase(getDebt.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDebt.fulfilled, (state, action: PayloadAction<DebtData>) => {
      state.loading = false;
      state.data = action.payload;
      state.cacheKey = 'debtCache';
    });
    builder.addCase(getDebt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'Something went wrong';
    });
  }
  
});

// Create async thunk for fetching key provisions data
export const getDebt = createAsyncThunk<
  DebtData,
  any,
  { state: RootState}
>("getDebt", async (payload: any, { getState, rejectWithValue }) => {
  const state = getState().debt;
  const updatedData = getState().updateData;

  if (state.cacheKey === 'debtCache') {
    // Return the current data if it exists in the state and cacheKey is set
    return updatedData.debtData;
  }
  
  try {
    const response:any = await postApiCall(`${baseUrl}Debt/GetDebtByAssetId?AssetId=${payload}`,payload);
    console.log('API response for Debt:', response);
    return response || {};
  } catch (error) {
    console.error('Error fetching Debt:', error);
    return rejectWithValue('Failed to fetch Debt data');
  }
});


// Export the reducer
export const { resetState : resetDebtStore } = debtFormSlice.actions;
export default debtFormSlice.reducer;